import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { ContactInfo, Timezone } from "model";

/**
* @class User
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.user;
* const user = new User(record);
* @property {NUMBER} _id - The id of the user
* @property {STRING} _first - The first name of the user
* @property {STRING} _last - The last name of the user
* @property {contactInfo} _email - the email contact info for the user
* @property {contactInfo} _phone - The phone contact info for the user
* @property {bcmsDate} _lastLogin - date when user logged in last
*/
export default class User extends BCMSRecord{
    _id;
    _name; 
    _first;
    _last;
    _email;
    _phone;
    _lastLogin;
    _timezone;

    constructor (record){     
      super( record  ) 
    }
  }
  User.define({
    "recordType":"user",
    "recordIDProp":"id",
    "className" : "User",
    "recordProperties":[
      /** 
       * @name userID
       * @instance
       * @property get {NUMBER} - gets the userID of the account
       * @property set {NUMBER} - sets the userID of the account
       * @memberof User 
       */
      BCMSRecordProperty.mapToString("id","_id","id"),
      /** 
       * @name first
       * @instance
       * @property get {STRING} - gets the first of the account
       * @property set {STRING} - sets the first of the account
       * @memberof User 
       */
      BCMSRecordProperty.mapToString("first","_first"),
      /** 
       * @name last
       * @instance
       * @property get {STRING} - gets the last of the account
       * @property set {STRING} - sets the last of the account
       * @memberof User 
       */
      BCMSRecordProperty.mapToString("last","_last"),
      /** 
       * @name email
       * @instance
       * @property get {contactInfo} - gets the email of the account
       * @property set {contactInfo} - sets the email of the account
       * @memberof User 
       */
      BCMSRecordProperty.mapToClass("email", "_email", () => ContactInfo),
      /** 
       * @name phone
       * @instance
       * @property get {contactInfo} - gets the phone of the account
       * @property set {contactInfo} - sets the phone of the account
       * @memberof User 
       */
      BCMSRecordProperty.mapToClass("phone", "_phone", () => ContactInfo),

      /** 
       * @name lastLogin
       * @instance
       * @property get {bcmsDate} - gets the lastLogin of the account
       * @property set {bcmsDate} - sets the lastLogin of the account
       * @memberof User 
       */
      BCMSRecordProperty.mapToDate("lastLogin","_lastLogin"),

      /**
       * @name timezone
       * @instance
       * @property get {timezone} - gets the timezone of the account
       * @property set {timezone} - sets the timezone of the account
       * @memberof User
       */
      BCMSRecordProperty.mapToClass("timezone", "_timezone", () => Timezone, "selectedTimezoneID")
    ]  
})




